'use strict';

require('../../style/css');

require('../../tabs/style/css');

require('./index.css');

require('../../badge/style/css');